export default "__VITE_ASSET__0LmMjX6L__ 640w, __VITE_ASSET__meicUU8Y__ 1024w";